import React, { Component } from 'react';
import ConstElement from '../../common/ConstElement';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { updateStateJobs } from "./service";
import 'react-toastify/dist/ReactToastify.css';
var EXIF = require("exif-js");

const MAX_NUMBER_IMAGES = 3;
const LIMIT_SIZE_UPLOAD = 10485760;

class EditCopyJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobs: props.jobs,
            // job: {work_start_date: null, work_end_date: null,},
            cities:[],
            prefs:[],
            bigCategories:[],
            smallCategories:[],
            images: [],
            disable: false,
            googleMapSrc: null,
            dontShowModal:false,
            currentEditingJobIndex: props.currentEditingJobIndex,
        }
        this.saveData = this.saveData.bind(this);
        this.setJobData = this.setJobData.bind(this);
        this.getJobData = this.getJobData.bind(this);
        this.setIndexData = this.setIndexData.bind(this);
        this.getIndexData = this.getIndexData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleChangeEditWorkStartDate = this.handleChangeEditWorkStartDate.bind(this);
        this.handleChangeEditWorkEndDate = this.handleChangeEditWorkEndDate.bind(this);
        this.handleCalculate = this.handleCalculate.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.renderPreview = this.renderPreview.bind(this);
        this.handleCropImage = this.handleCropImage.bind(this);
        this.handleSelectShow = this.handleSelectShow.bind(this);
        this.renderUploadBtn = this.renderUploadBtn.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.setGoogleMapSrc = this.setGoogleMapSrc.bind(this)
        this.handlePublicationTypeChange = this.handlePublicationTypeChange.bind(this);
        this.handleChangeEditPostPeriodStartDate = this.handleChangeEditPostPeriodStartDate.bind(this);
        this.handleChangeEditPostPeriodEndDate = this.handleChangeEditPostPeriodEndDate.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        const { jobs,currentEditingJobIndex } = this.state
        // HasPermission('/api/jobs/delete').then(permission => { this.setState({ hasPermissionCancel: permission }) });
        var callback = () => {
            if (this.state.prefs && this.state.cities && this.state.jobs[currentEditingJobIndex].pref && this.state.jobs[currentEditingJobIndex].city) {
                this.setGoogleMapSrc(this.state.jobs[currentEditingJobIndex]);
            }
        };

        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            },callback);
        })
        axios.get('/api/prefs2').then(response => {
            this.setState({
                prefs: response.data
            },callback);
        })
        axios.get('/api/big-categories').then(response => {
            this.setState({
                bigCategories: response.data
            });
        })
        axios.get('/api/small-categories').then(response => {
            this.setState({
                smallCategories: response.data
            });
        })
        if (this.state.jobs.length && currentEditingJobIndex >= 0) {
            // const jobData = [...this.state.jobs];
            let images = this.state.jobs[currentEditingJobIndex].images;
            let images_path = this.state.jobs[currentEditingJobIndex].images_path;
            let original_images_path = this.state.jobs[currentEditingJobIndex].images_path;
            // let imgState = [];
            // images_path.map((img, index) => {
            //     imgState.push({
            //         url: original_images_path[index],
            //         url_crop: img,
            //         selected: images[index].is_selected,
            //         rotate: 0
            //     });
            // })
            this.setState({ images: images });
            // this.setState({ jobs: jobData });
            if (images_path.length == MAX_NUMBER_IMAGES) {
                this.setState({ disable: true });
            }
        }

        // if (this.props.match.params.hasOwnProperty('id')) {
        //     this.getJobById(callback);
        // }
    }
    // componentDidUpdate(prevProps){
    //     if(prevProps.jobs !== this.props.jobs){
    //         this.setJobData(this.props.jobs);
    //     }
    //     if(prevProps.currentEditingJobIndex !== this.props.currentEditingJobIndex){
    //         this.setIndexData(this.props.currentEditingJobIndex);
    //     }
    // }
    setGoogleMapSrc(job) {
        const { jobs,currentEditingJobIndex } = this.state
        let googleMapParam = ''
        let tokyoPrefId = [13, 14];
        let pref = this.state.prefs.filter(pref => pref.id == job.pref)[0]
        let city = this.state.cities.filter(city => city.id == job.city)[0]

        if (!pref || !city) {
            return;
        }

        if (tokyoPrefId.indexOf(job.pref) >= 0) {
            googleMapParam = `東京都${city.name}${job.address}`
        } else {
            googleMapParam = `${pref.name}${city.name}${job.address}`
        }
        let src = `https://maps.google.co.jp/maps?q=${googleMapParam}&z=18&output=embed&iwloc=J&t=m`;
        this.setState({ src: src });
    }


    /**
     * Get job by id
     */
    // getJobById(callback) {
    //     const jobId = this.props.match.params.id
    //     axios.get('/api/jobs/' + jobId).then(response => {
    //         if (response.data) {
    //             this.setData(response.data);
    //             if (callback) {
    //                 callback
    //             }
    //         }
    //         this.getJobApplys();
    //     }).catch(() => {
    //         this.props.history.push('/_404');
    //     })
    // }

    /**
     * Process change work start date
     */
    handleChangeEditWorkStartDate(date,index) {
        const jobData = [...this.state.jobs];
        jobData[index].work_start_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({jobs: jobData});
    }

    /**
     * Process change work end date
     */
    handleChangeEditWorkEndDate(date,index) {
        const jobData = [...this.state.jobs];
        jobData[index].work_end_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({jobs: jobData});
    }

     /**
     * Process change work end date
     */
     handleCalculate(event,index) {
        const jobData = [...this.state.jobs];
        jobData[index].staff_price = event.target.value;
        jobData[index].system_fee = Math.floor(jobData[i].staff_price * (this.state.jobs[index].system_fee_per / 100));
        jobData[index].staff_total = +jobData[index].staff_price + +jobData[index].system_fee;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({jobs: jobData});
    }

    /**
     * Process change staff_price basis
     */
    handleHoujinCalculate(event) {
        const jobData = [...this.state.jobs];
        // let staff_price_per = (100 - this.state.job.system_fee_per) / 100;
        jobData[index].staff_price = event.target.value;
        jobData[index].system_fee = Math.floor(jobData[index].staff_price * (jobData[index].system_fee_per / 100));
        jobData[index].staff_total = +jobData[index].staff_price + +jobData[index].system_fee;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({jobs: jobData});
    }

    /**
     * Set data of job
     * data: Object Job
     */
    setJobData(data) {
        this.setState({
            jobs: data
        })
    }
    /**
     * Get data of job
     */
    getJobData() {
        return this.state.jobs;
    }
    setIndexData(data) {
        this.setState({
            currentEditingJobIndex: data
        })
    }
    getIndexData() {
        return this.state.currentEditingJobIndex;
    }
    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event,index) {
        const jobData = [...this.state.jobs];
        jobData[index][event.target.name] = event.target.value;
        let src = '';
        switch (event.target.name) {
            case 'free_category':
                jobData[index].category_type = 2
                break;
            case 'big_category':
                jobData[index].category_type = 1
                break;
            case 'small_category':
                jobData[index].category_type = 1
                break;
            case 'pref':
                if (jobData[index].city && jobData[index].address) {
                    let src = this.setGoogleMapSrc(jobData[index]);
                    this.handleUpdateGoogleMap(src)
                }
                break;
            case 'city':
                if (jobData[index].pref && jobData[index].address) {
                    let src = this.setGoogleMapSrc(jobData[index]);
                    this.handleUpdateGoogleMap(src)
                }
                break;
            default:
                break;
        }
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({ jobs: jobData });
    }
    handlePublicationTypeChange(event,index) {
        const jobData = [...this.state.jobs];
        //set request time
        // 期間指定型はstaff_countは1人固定
        jobData[index].staff_count = 1;
        jobData[index][event.target.name] = event.target.value;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({ jobs: jobData });
    }
    handleChangeEditPostPeriodStartDate(date,index) {
        const jobData = [...this.state.jobs];
        jobData[index].post_period_start_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({ jobs: jobData });
    }
    handleChangeEditPostPeriodEndDate(date,index) {
        const jobData = [...this.state.jobs];
        jobData[index].post_period_end_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobData}))
        );
        this.setState({ jobs: jobData });
    }


    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let jobs = this.getJobData();
        let index = this.getIndexData();
        //to top
        window.scrollTo(0, 0)
        jobs[index]['images'] = this.state.images;
        axios.post('/api/jobs/validate', jobs[index])
            .then(response => {
            // 依頼のフォーマットチェックして一括コピー一覧に戻れるか分岐
            if (response.status === 200) {
                this.props.history.push("/houjin/jobs/copy");
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }

    handleUpload(e) {
        let image = e.currentTarget.files[0];
        if(image.size > LIMIT_SIZE_UPLOAD){
            alert("10MB以下の画像をアップロードしてください");
            e.target.value = '';
        } else {
            let imgState = this.state.images;
            let url = this.readFile(image);
            let rotate = this.getRotate(image);

            Promise.all([url, rotate]).then(res => {
                imgState.push({
                    url: res[0],
                    url_crop: res[0],
                    selected: false,
                    rotate: res[1]
                });
                if (!_.find(imgState, img => img.selected)) {
                    imgState[0]["selected"] = true;
                }
                this.setState({ images: imgState });
                if (this.state.images.length == MAX_NUMBER_IMAGES) {
                    this.setState({ disable: true });
                }
            });
        }
    }

    readFile(file) {
        return new Promise((resolve, reject) => {
          var fr = new FileReader();
          fr.onload = (e) => {
            var img = document.createElement("img");
            img.onload = () => {
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              var MAX_WIDTH = 800;
              var MAX_HEIGHT = 800;
              var width = img.width;
              var height = img.height;

              if (width > height) {
                if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width;
                  width = MAX_WIDTH;
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height;
                  height = MAX_HEIGHT;
                }
              }
              canvas.width = width;
              canvas.height = height;
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);
              var dataurl = canvas.toDataURL("image/png");
              resolve(dataurl);
            };
            img.src = e.target.result;
          };
          fr.readAsDataURL(file);
        });
    }

    getRotate(file) {
    return new Promise((resolve, reject) => {
        EXIF.getData(file, function() {
        var orientation = EXIF.getTag(this, "Orientation");
        let rotatePic = 0;
        switch (orientation) {
            case 8:
            rotatePic = 270;
            break;
            case 6:
            rotatePic = 90;
            break;
            case 3:
            rotatePic = 180;
            break;
            default:
            rotatePic = 0;
        }
        resolve(rotatePic);
        });
    });
    }

    handleCropImage(index) {
        let imgState = this.state.images;
        imgState[index]['url_crop'] = this[`${index}_ref`].getImageScaledToCanvas().toDataURL();
        this.setState({ images: imgState });
    }

    handleSelectShow(index) {
        let imgState = this.state.images;
        for (let i = 0; i < imgState.length; i++) {
          imgState[i]["selected"] = i === index;
        }
        this.setState({ images: imgState });
    }

    handleRemove(index) {
        let imgState = this.state.images;
        imgState.splice(index, 1);
        this.setState({ images: imgState });
        if (this.state.disable) {
          this.setState({ disable: false });
        }
    }

    renderPreview() {
        return this.state.images.map((image, index) => {
            return (
                <div key={index} className="row pb-2">
                    <div className="col-sm-4">
                        <div
                            style={{ maxWidth: 200, maxHeight: "auto" }}
                            className="my-auto d-flex justify-content-center align-items-center"
                        >
                            <img src={image.url_crop} />
                        </div>
                        <button
                            type="button"
                            aria-label="Close"
                            className="position-absolute close"
                            onClick={e => this.handleRemove(index)}
                            style={{ right: -5, top: 0 }}
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="col-sm-6 my-auto checkbtn-radio">
                        <label>
                            <input type="checkbox"
                                checked={image.selected}
                                onChange={e => this.handleSelectShow(index)}
                            />
                            <span>メイン画像にする</span>
                        </label>
                    </div>
                </div>
            );
        });
    }

    renderUploadBtn() {
        // if (this.state.disable || this.state.jobs.is_copy) {
        if (this.state.disable) {
          return;
        }

        return (
            <div>
                {React.createElement(
                    'input',
                    {type: 'file', accept: '.png, .jpg', id: 'upload-file', onChange: this.handleUpload, className: 'btn w-100 d-none'},
                )}
                <label htmlFor="upload-file">
                    <h3 className="btn btn-secondary">アップロードする</h3>
                </label>
            </div>
        );
    }
    // renderJobImages() {
    //     let images = [
    //         '/img/detail_1.png',
    //     ];

    //     if (this.state.jobs.images_path && this.state.jobs.images_path.length) {
    //         images = this.state.jobs.images_path;
    //     }

    //     return (
    //         <div className="form-group row">
    //             <label className="col-sm-4 col-form-label text-right">依頼画像</label>
    //             <div className="col-sm-10">
    //                 {images.map((img, index) => {
    //                     return (
    //                         <img key={index} src={img} width="200" height="200" className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
    //                     );
    //                 })}
    //             </div>
    //         </div>
    //     );
    // }


    render() {
        const src = this.state.src
        const { currentEditingJobIndex } = this.props
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/jobs">依頼一覧</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/jobs/copy">一括コピー</a></li>
                                <li className="breadcrumb-item active" aria-current="page">依頼編集</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                            <div className="card">
                                <div className="card-header p-4 border-bottom-0">
                                    <div className="row">
                                        <div className="col"><h4 className="mb-0">依頼編集</h4></div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label font-size"><p className="h5 font-weight-normal">契約形態</p></label>
                                        <div className="col-8 col-sm-10 pt-2">
                                            <label className="mt-1 h5 font-weight-normal">{this.state.jobs && this.state.jobs[currentEditingJobIndex].payment_method == 1 ? '委任' : '直雇用'}</label>
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">依頼者</label>
                                        <div className="col-sm-10">
                                            {(this.state.jobs.first_last_name || (this.state.jobs.client && this.state.jobs.client.firstname && this.state.jobs.client.lastname)) ?
                                                <label className="col-value text-left text-primary"><a href={this.state.jobs.clientId ? "/accounts/edit/" + this.state.jobs.clientId : this.state.jobs.client.id}>{this.state.jobs.first_last_name ? this.state.jobs.first_last_name : this.state.jobs.client.firstname+this.state.jobs.client.lastname}</a></label>
                                            : ''}
                                        </div>
                                    </div>
                                    {this.renderListOrderHistories()}
                                    <div className={this.state.jobs.combini_order_id ? '' : 'd-none'}>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">コンビニ決済のオーダーID</label>
                                            <div className="col-sm-10">
                                            <label className="col-value text-left">{this.state.jobs.combini_order_id}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">コンビニ決済のステータス</label>
                                            <div className="col-sm-10">
                                            <label className="col-value text-left">{this.state.jobs.combini_status_text}</label>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className="mb-4 mb-sm-2">
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">タイトル</p></label>
                                            <div className="col-sm-10">
                                                <span className={this.state.jobs && this.state.jobs[currentEditingJobIndex].category_type==1 ? 'badge bg-pink text-white mt-1' : 'badge bg-purple text-white mt-1'}>{this.state.jobs && this.state.jobs[currentEditingJobIndex].category_type==1 ? 'カテゴリで選ぶ' : '入力する'}</span>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="mb-4 mb-sm-2">
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">タイトル</p></label>
                                            <div className="col-sm-10">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'free_category', value: this.state.jobs[currentEditingJobIndex].free_category || "", className: 'form-control'},
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div >
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">大カテゴリ</p></label>
                                            <div className="col-8 col-sm-5">
                                                <select onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="big_category_id" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].big_category_id ? this.state.jobs[currentEditingJobIndex].big_category_id : ''} className="form-control" >
                                                    {this.state.bigCategories.map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">小カテゴリ</p></label>
                                            <div className="col-8 col-sm-5">
                                                <select onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="small_category_id" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].small_category_id ? this.state.jobs[currentEditingJobIndex].small_category_id : ''} className="form-control" >
                                                    {this.state.smallCategories.filter(small_category_id => small_category_id.big_category_id == this.state.jobs[currentEditingJobIndex].big_category_id).map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">作業日</p></label>
                                        <div className="col-8 col-sm-8 pt-2">
                                            <div className="row">
                                                <div className="col-12 col-sm-3">
                                                    <input onChange={(e)=>this.handlePublicationTypeChange(currentEditingJobIndex)} value="2" type="radio" name="publication_type" id="publication_type2" checked={this.state.jobs && this.state.jobs[currentEditingJobIndex].publication_type == 2 || this.state.jobs[currentEditingJobIndex].publication_type == null ? 'checked' : ''} disabled/>
                                                    <label htmlFor="publication_type2" className="ml-1 mr-3"><p className="h5 font-weight-normal">期間指定</p></label>
                                                </div>
                                                <div className="col-12 col-sm-3">
                                                    <input onChange={(e)=>this.handlePublicationTypeChange(currentEditingJobIndex)} value="1" type="radio" name="publication_type" id="publication_type1" checked={this.state.jobs && this.state.jobs[currentEditingJobIndex].publication_type == 1 ? 'checked' : ''} disabled/>
                                                    <label htmlFor="publication_type1" className="ml-1"><p className="h5 font-weight-normal">日付指定</p></label>
                                                </div>
                                            </div>
                                            <div>
                                                <span>期間指定では、期間中に1回作業を依頼します。</span>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.jobs && this.state.jobs[currentEditingJobIndex].publication_type == 2 ? (
                                    <>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 form-label text-left" htmlFor=""><p className="h5 font-weight-normal">期間</p></label>
                                            <div class="col-9 col-sm-10 row">
                                                <div class="col-8 col-sm-4 input-group mb-3">
                                                    <DatePicker
                                                        locale="ja-JP"
                                                        className="form-control form_datepicker"
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={this.state.jobs[currentEditingJobIndex].post_period_start_date ? moment(new Date(this.state.jobs[currentEditingJobIndex].post_period_start_date)) : null}
                                                        selectsStart
                                                        onChange={(date,e)=>this.handleChangeEditPostPeriodStartDate(date,currentEditingJobIndex)}
                                                        minDate={moment()}
                                                        placeholderText="2023/02/01"
                                                        disabledKeyboardNavigation
                                                        startDate={this.state.jobs[currentEditingJobIndex].post_period_start_date}
                                                        endDate={this.state.jobs[currentEditingJobIndex].post_period_end_date}

                                                    />
                                                    <div className="input-group-append job-input-group-append">
                                                        <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                    </div>
                                                </div>
                                                <div className="pt-1 text-center">
                                                    <span>～</span>
                                                </div>
                                                <div className="col-8 col-sm-4 input-group">
                                                    <DatePicker
                                                        locale="ja-JP"
                                                        className="form-control form_datepicker"
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={this.state.jobs[currentEditingJobIndex].post_period_end_date ? moment(new Date(this.state.jobs[currentEditingJobIndex].post_period_end_date)) : null}
                                                        selectsEnd
                                                        onChange={(date,e)=>this.handleChangeEditPostPeriodEndDate(date,currentEditingJobIndex)}
                                                        minDate={moment()}
                                                        placeholderText="2023/02/28"
                                                        disabledKeyboardNavigation
                                                        startDate={this.state.jobs[currentEditingJobIndex].post_period_start_date}
                                                        endDate={this.state.jobs[currentEditingJobIndex].post_period_end_date}

                                                    />
                                                    <div className="input-group-append job-input-group-append">
                                                        <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row row-cols-3 mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">時間帯</p></label>
                                            <div className="col-3 col-sm-2 mb-3 pr-0">
                                                <ConstElement onElementChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} element="jobs.post_period_start_time" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].post_period_start_time ? this.state.jobs[currentEditingJobIndex].post_period_start_time : ''} />
                                            </div>
                                            <div className="pt-1 text-center pr-3 pl-3">
                                                <span>～</span>
                                            </div>
                                            <div className="col-3 col-sm-2 pl-0">
                                                <ConstElement onElementChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} element="jobs.post_period_end_time" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].post_period_end_time ? this.state.jobs[currentEditingJobIndex].post_period_end_time : ''} />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">作業時間<br className="d-block d-sm-none"/>(目安)</p></label>
                                            <div className="col-8 col-sm-5">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'approximate_time', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].approximate_time|| "", className: 'form-control', placeholder: '15分'}
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row row-cols-3 mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">作業時間<br className="d-block d-sm-none"/>(目安)</p></label>
                                            <div className="col-8 col-sm-10">
                                                <textarea onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="approximate_time_comment" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].approximate_time_comment ? this.state.jobs.approximate_time_comment : ''} className="form-control" rows="10"></textarea>
                                            </div>
                                        </div>
                                    </>
                                    ): (
                                    <>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">勤務日</p></label>
                                            <div className="col-8 col-sm-5">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={moment(new Date(this.state.jobs[currentEditingJobIndex].work_start_date))}
                                                    onChange={(date,e)=>this.handleChangeEditWorkStartDate(date,currentEditingJobIndex)}
                                                    minDate={moment()}
                                                    maxDate={moment().add(30, 'days')}
                                                    placeholderText="例）2019/09/30"
                                                    disabledKeyboardNavigation
                                                />
                                                <div className="input-group-append job-input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={this.state.jobs[currentEditingJobIndex].request_time_type == 2 ? 'd-none' : ''}>
                                            <div className="form-group row mb-4 mb-sm-2">
                                                <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">勤務開始時間</p></label>
                                                <div className="col-8 col-sm-5">
                                                    <ConstElement onElementChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} element="jobs.work_start_time_houjin" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].work_start_time ? this.state.jobs[currentEditingJobIndex].work_start_time : ''} />
                                                </div>
                                            </div>
                                            <div className="form-group row mb-4 mb-sm-2">
                                                <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">勤務終了時間</p></label>
                                                <div className="col-8 col-sm-5">
                                                    <ConstElement onElementChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} element="jobs.work_end_time" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].work_end_time ? this.state.jobs[currentEditingJobIndex].work_end_time : ''} />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    )}
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">郵便番号</p></label>
                                        <div className="col-8 col-sm-3">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'zip_no', value: this.state.jobs[currentEditingJobIndex].zip_no|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">都道府県</p></label>
                                        <div className="col-8 col-sm-5">
                                            <select onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="pref" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].pref ? this.state.jobs[currentEditingJobIndex].pref : ''} className="form-control" >
                                            {this.state.prefs.map((dataRow, i) => {
                                                return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                            })}
                                            </select>
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">都道府県内全ての市区に掲載</label>
                                        <div className="col-sm-10">
                                            <input onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} type="checkbox" name="all_cities" value="1" checked={this.state.jobs && this.state.jobs[currentEditingJobIndex].all_cities == 1 ? 'checked' : ''} className="form-checkbox"/>
                                            <p className="text-left text-danger">
                                                ※お仕事詳細での「場所」の表記が都道府県までの表示となります。
                                            </p>
                                        </div>
                                    </div> */}
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">市区</p></label>
                                        <div className="col-8 col-sm-5">
                                            <select onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="city" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].city ? this.state.jobs[currentEditingJobIndex].city : ''} className="form-control" >
                                                {this.state.cities.filter(city => city.pref_id == this.state.jobs[currentEditingJobIndex].pref).map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">町名・番地</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'address', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].address|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">ビル・建物名</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'address2', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].address2|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">マップ自動連携</p></label>
                                        <div className="col-sm-7">
                                            <span>上記の住所に合わせてピンを自動設定しております。</span>
                                            <div className="row mt-3 mb-2">
                                                <div className="col-12 col-sm-6">
                                                    <input
                                                        // onChange={this.handleMapLinkage}
                                                        value="1"
                                                        type="radio"
                                                        name="use_map_flg"
                                                        id="use_map_flg1"
                                                        checked={this.state.jobs && this.state.jobs[currentEditingJobIndex].use_map_flg == 1 ? 'checked' : ''}
                                                        onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)}
                                                    />
                                                    <label htmlFor="use_map_flg1" className="ml-1 mr-3"><p className="h5 font-weight-normal">このマップを使用する</p></label>
                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                    <input
                                                        // onChange={this.handleMapLinkage}
                                                        value="0"
                                                        type="radio"
                                                        name="use_map_flg"
                                                        id="use_map_flg2"
                                                        checked={this.state.jobs && this.state.jobs[currentEditingJobIndex].use_map_flg == 0 ? 'checked' : ''}
                                                        onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)}
                                                    />
                                                    <label htmlFor="use_map_flg2" className="ml-1"><p className="h5 font-weight-normal">このマップを使用しない</p></label>
                                                </div>
                                            </div>
                                            <div className="">
                                                <iframe frameborder="0" scrolling="auto" marginheight="0" marginwidth="0" src={src} className="w-100"></iframe>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">最寄駅</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'station_name', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].station_name|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">最寄駅まで</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'to_station', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].to_station|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">詳細</p></label>
                                        <div className="col-sm-10">
                                            <textarea onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="note" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].note ? this.state.jobs[currentEditingJobIndex].note : ''} className="form-control" rows="16"></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">詳細補足URL</p></label>
                                        <div className="col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'job_description_url', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].job_description_url|| "", className: 'form-control', placeholder: ''},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">リンクテキスト</p></label>
                                        <div className="col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'job_description_text', value: this.state.jobs && this.state.jobs[currentEditingJobIndex].job_description_text|| "", className: 'form-control', placeholder: ''},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">入職経路</p></label>
                                        <div className="col-sm-10">
                                            <textarea onChange={(e)=>this.handleInptChange(e,currentEditingJobIndex)} name="job_detail" value={this.state.jobs && this.state.jobs[currentEditingJobIndex].job_detail ? this.state.jobs[currentEditingJobIndex].job_detail : ''} className="form-control" rows="8" disabled></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">募集人数</p></label>
                                        <div className="col-8 col-sm-8 pt-1">
                                            {this.state.jobs && this.state.jobs[currentEditingJobIndex].publication_type == 2 ? (
                                                <label class="col-value text-left">1人</label>
                                            ):(
                                                <div className="input-group">
                                                    {
                                                        React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: (e)=>this.handleInptChange(e,currentEditingJobIndex), name: 'staff_count', value: this.state.jobs[currentEditingJobIndex].staff_count, className: 'form-control'},
                                                    )}
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">人</span>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.jobs && this.state.jobs[currentEditingJobIndex].publication_type == 1 ? (
                                                <div className="text-danger">
                                                    <span>※1～99人で設定が可能です。</span>
                                                </div>
                                            ):('')}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">募集金額</p><span className="text-danger font-weight-normal">※日給</span></label>
                                        <div className="col-8 col-sm-10 pt-1">
                                            <div className='row'>
                                                <p className="col-1 pt-2">¥</p>
                                                <div className="col-10 pl-0">
                                                    {
                                                        React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: (e)=>this.handleHoujinCalculate(currentEditingJobIndex), placeholder: '金額は10円単位で設定可能です', name: 'staff_price', defaultValue: this.state.jobs && this.state.jobs[currentEditingJobIndex].staff_price || "", className: 'form-control'},
                                                    )}
                                                    <span>¥10単位で入力してください。</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className=" h5 font-weight-normal">システム利用料</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{'¥' + parseInt(this.state.jobs[currentEditingJobIndex].system_fee).toLocaleString()}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">システム利用料%</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.jobs[currentEditingJobIndex].system_fee_per + '%'}</label>
                                        </div>
                                        </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">お支払い金額（税抜）</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.jobs && this.state.jobs[currentEditingJobIndex].staff_total ? '¥' + parseInt(this.state.jobs[currentEditingJobIndex].staff_total).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">依頼合計金額（税抜）</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.jobs && this.state.jobs[currentEditingJobIndex].staff_total ? '¥' + parseInt(this.state.jobs[currentEditingJobIndex].staff_total * this.state.jobs[currentEditingJobIndex].staff_count).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0">
                                            <span className="h5 font-weight-normal">依頼画像<br /></span>
                                            <span class="small">※3枚まで登録可能</span><br/>
                                            <span class="small">※メイン画像に<br class="d-block d-sm-none" />チェック</span>
                                        </label>
                                        <div className="col-8 col-sm-10">
                                            {this.renderPreview()}
                                            {this.renderUploadBtn()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-sm-12">
                                    <div className="card-footer">
                                        <div className="text-center">
                                            <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">保存する</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => {
    const {jobs,currentEditingJobIndex} = state.job

    return {
        jobs: jobs,
        currentEditingJobIndex: currentEditingJobIndex,
    }
}

export default withRouter(connect(mapStateToProps)(EditCopyJob))
